import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShoppingBag, Truck } from "lucide-react";
import { api } from "../lib/site";
import PageHero from "../components/site/PageHero";

const EASE = [0.16, 1, 0.3, 1];

export default function Shop() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="shop-page">
      <PageHero
        overline="Nervani Beauty Products"
        title="Premium beauty, beautifully made."
        subtitle="From the Glow On The Go Collection to natural cuticle care and hydration oils — shop products crafted to make you feel radiant."
      />

      <div data-testid="shop-batch-note" className="bg-brand-blush border-b border-brand-ink/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-4 flex items-center justify-center gap-3 text-center">
          <Truck size={18} className="text-brand-rose shrink-0" strokeWidth={1.6} />
          <p className="text-sm md:text-base tracking-wide text-brand-ink font-light">
            Small-batch made with care. <span className="font-medium">Ships weekly, every Monday.</span>
          </p>
        </div>
      </div>

      <section className="bg-brand-cream py-24 md:py-32" data-testid="shop-grid">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="grid gap-x-7 gap-y-14 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4">
            {products.map((p, i) => (
              <motion.div
                key={p.id}
                data-testid={`product-card-${p.id}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease: EASE, delay: (i % 4) * 0.08 }}
                className="group flex flex-col"
              >
                <div className="relative w-full overflow-hidden rounded-3xl bg-brand-blush h-80 flex items-center justify-center">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="max-w-[85%] max-h-[85%] object-contain mix-blend-multiply transition-transform duration-[900ms] group-hover:scale-105 drop-shadow-[0_20px_40px_rgba(120,60,80,0.15)]"
                  />
                  {p.badge && <span className="absolute top-4 left-4 bg-brand-ink text-brand-cream text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 rounded-full">{p.badge}</span>}
                </div>
                <div className="mt-6 flex items-start justify-between gap-4">
                  <div>
                    <span className="text-[11px] uppercase tracking-[0.22em] text-brand-rose">{p.category}</span>
                    <h3 className="font-serif text-2xl text-brand-ink tracking-tight mt-1">{p.name}</h3>
                  </div>
                  <span className="font-serif text-brand-rose text-2xl whitespace-nowrap">{p.price}</span>
                </div>
                <p className="text-brand-ink/70 font-light mt-3 leading-relaxed text-sm">{p.description}</p>
                <a
                  href={p.checkout_url || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`product-buy-${p.id}`}
                  className="btn-fill bg-brand-ink text-brand-cream rounded-full px-6 py-3 text-sm font-medium mt-6 inline-flex items-center justify-center gap-2 self-start hover:bg-brand-rose transition-colors"
                >
                  <ShoppingBag size={16} /> Buy Now
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
